// Serbian

export default {

  component: {
    jobAdList: {
      title: 'Otvorena radna mesta',
      jobs: 'poslovi',
      noJobAds: 'Trenutno nema otvorenih radnih mesta.',
    },

    jobAdCard: {
      openUntil: date => `Otvoreno do ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Hvala vam.',
      readyInfo: 'Primili smo vašu prijavu. Uskoro će vam se javiti regruter.',
      luck: 'Srećno!',
    },

    jobAdSeeYou: {
      title: 'Hvala vam.',
      description: 'Vaša prijava je sačuvana i poslali smo vam link preko kog je možete nastaviti kasnije.',
    },

    unpublished: {
      title: 'Nije objavljeno',
      info: 'Oglas za posao još uvek nije objavljen.',
    },
  },

  page: {},

}
